import { render, staticRenderFns } from "./mapbg3.vue?vue&type=template&id=354bab8c&scoped=true"
import script from "./mapbg3.vue?vue&type=script&lang=js"
export * from "./mapbg3.vue?vue&type=script&lang=js"
import style0 from "./mapbg3.vue?vue&type=style&index=0&id=354bab8c&prod&scoped=true&lang=scss"
import style1 from "./mapbg3.vue?vue&type=style&index=1&id=354bab8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354bab8c",
  null
  
)

export default component.exports